import { render, staticRenderFns } from "./VDetailsPopover.vue?vue&type=template&id=cc1c4706&"
import script from "./VDetailsPopover.vue?vue&type=script&lang=js&"
export * from "./VDetailsPopover.vue?vue&type=script&lang=js&"
import style0 from "./VDetailsPopover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VPopoverCloseBtn: require('/app/components/ui/v-popover-close-btn/VPopoverCloseBtn.vue').default,VCard: require('/app/components/ui/v-card/VCard.vue').default})
